import * as React from 'react';
import * as styles from './Content.css';

export const Content = (props: React.PropsWithChildren<{}>): React.JSX.Element => {
  return <div className={styles['content']}>{props.children}</div>;
};
